// 3rd Party
import PropTypes from 'prop-types';
import React from 'react';

// Component
const DefaultProfileImageSvg = ({ height = '200px', width = '200px' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={width}
    height={height}
    viewBox="0 0 200 200"
    role="presentation"
  >
    <defs>
      <path id="a" d="M0 0h200v200H0z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <image width={width} height={height} />
      <use fill="#CBE0E0" xlinkHref="#a" />
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M99.8 128.878c25.283 0 45.968-20.685 45.968-45.967 0-25.28-20.685-45.966-45.967-45.966-25.28 0-45.967 20.685-45.967 45.967 0 25.283 20.686 45.968 45.968 45.968zm79.524 49.645c-1.61-4.597-4.597-11.722-7.355-17.008-13.56-25.742-37.234-35.624-59.07-24.363-8.503 4.367-17.696 4.367-25.97 0-21.835-11.032-45.738-1.38-59.298 24.133a126.436 126.436 0 00-7.355 17.008c-1.072 3.218-2.45 10.573-4.137 22.064H183.46c-1.685-11.49-3.064-18.77-4.136-21.834z"
      />
    </g>
  </svg>
);
DefaultProfileImageSvg.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
};

export default DefaultProfileImageSvg;
